export const CatalogCertificates = {
  en: {
    Certificates: 'Certificates',
    'Create Certificate': 'Create Certificate',
    'Certificate face value': 'Face value',
    'Available online': 'Available online',
    Status: 'Status',
  },
  uk: {
    Certificates: 'Сертифікати',
    'Create Certificate': 'Створити сертифікат',
    'Certificate face value': 'Номінал',
    'Available online': 'Доступний онлайн',
    Status: 'Статус',
  },
};

export const CatalogCertificateForm = {
  en: {
    ...CatalogCertificates.en,
    'New Certificate': 'New Certificate',
    'Edit Certificate': 'Edit Certificate',
    'Update Certificate': 'Update Certificate',
    Remove: 'Remove',
    'Certificate name hint':
      'The name the client sees in the online catalogue.',
    'Certificate description hint':
      'What the certificate includes. Shown on the certificate page.',
    'Certificate photo': 'Image',
    'Certificate photo hint':
      'Shown on the certificate card in the online catalogue. Optional.',
    'Certificate locations hint':
      'Where the certificate applies. Every service and card in the composition must be available at every location selected here.',
    'Certificate available online hint':
      'Only certificates marked available online appear in the client catalogue and can be bought.',
    'Certificate composition': 'Certificate contents',
    'No certificate items yet': 'Add at least one service, card or deposit.',
    'Add certificate item': 'Add item',
    'Certificate item kind': 'Type',
    'Certificate item service': 'Service',
    'Certificate item card': 'Card',
    'Certificate item deposit': 'Deposit',
    'Certificate item sellable': 'Catalog item',
    'Select catalog item': 'Select from catalog',
    'No results.': 'No results.',
    'Certificate item count': 'Quantity',
    'Certificate item value': 'Line value',
    'Deposit amount': 'Deposit amount',
    'Certificate single deposit':
      'A certificate may include only one deposit line.',
    'Certificate face value hint':
      'Computed from current catalog prices. The amount the client actually pays is snapshotted when the purchase starts.',
  },
  uk: {
    ...CatalogCertificates.uk,
    'New Certificate': 'Новий сертифікат',
    'Edit Certificate': 'Редагування сертифіката',
    'Update Certificate': 'Оновити сертифікат',
    Remove: 'Видалити',
    'Certificate name hint': 'Назва, яку клієнт бачить в онлайн-каталозі.',
    'Certificate description hint':
      'Що входить у сертифікат. Показується на сторінці сертифіката.',
    'Certificate photo': 'Зображення',
    'Certificate photo hint':
      'Показується на картці сертифіката в онлайн-каталозі. Необовʼязкове.',
    'Certificate locations hint':
      'Де діє сертифікат. Кожна послуга та картка з наповнення мають бути доступні в усіх обраних локаціях.',
    'Certificate available online hint':
      'Лише сертифікати, позначені як доступні онлайн, зʼявляються в каталозі клієнта і доступні до купівлі.',
    'Certificate composition': 'Наповнення сертифіката',
    'No certificate items yet':
      'Додайте щонайменше послугу, картку або депозит.',
    'Add certificate item': 'Додати позицію',
    'Certificate item kind': 'Тип',
    'Certificate item service': 'Послуга',
    'Certificate item card': 'Картка',
    'Certificate item deposit': 'Депозит',
    'Certificate item sellable': 'Позиція каталогу',
    'Select catalog item': 'Обрати з каталогу',
    'No results.': 'Нічого не знайдено.',
    'Certificate item count': 'Кількість',
    'Certificate item value': 'Вартість позиції',
    'Deposit amount': 'Сума депозиту',
    'Certificate single deposit':
      'Сертифікат може містити лише одну позицію депозиту.',
    'Certificate face value hint':
      'Розраховується за поточними цінами каталогу. Сума, яку фактично платить клієнт, фіксується на момент початку покупки.',
  },
};
